import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { ExtraConfig } from '@gov-nx/core/app/extra-config/context.types';
import { pageRouteResolver } from '@gov-nx/web/Router/routeResolver';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const ServiceResolver = lazy(() =>
	import('./ServiceResolver').then(({ ServiceResolver }) => ({
		default: ServiceResolver,
	}))
);

export const getServiceRoutes = (
	extraConfig: ExtraConfig['serviceRoutes']
): RouteObject[] => {
	const path = pageRouteResolver('sluzba');

	return path
		? [
				{
					path: path,
					children: [
						{
							path: ':serviceSlug/*',
							element: (
								<AuthorizedRoute>
									<ServiceResolver {...extraConfig.serviceResolverConfig} />
								</AuthorizedRoute>
							),
						},
					],
				},
			]
		: [];
};
